import styled from 'styled-components';
import { PAGE_SIDE_PADDING } from '../../common/styles/Layout';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FontWeight, FONT_STACK } from '../../common/styles/constants';
import { responsiveInterpolate } from '../../common/styles/responsiveInterpolate';

export const Container = styled.div`
  background-color: ${ThemeColours.white};
  border-bottom: 1px solid ${ThemeColours.mono200};
  ${FONT_STACK};
  color: ${ThemeColours.black};
  height: ${responsiveInterpolate(56, 72)};
  overflow-x: auto;
  overflow-y: visible;
`;

export const PillRow = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  margin: 0 auto;
  padding-left: ${PAGE_SIDE_PADDING};
  padding-right: ${PAGE_SIDE_PADDING};

  > * {
    margin-inline-end: 8px;

    :last-child {
      margin-inline-end: 0;
    }
  }
`;

export const TextDescription = styled.span`
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 16px;
  margin-inline-end: 24px;
`;

export const MapSearchLink = styled.span`
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 16px;
  margin-inline-end: 24px;
  text-decoration: underline;
`;
